import { render, staticRenderFns } from "./yincan.vue?vue&type=template&id=42a77c66&scoped=true&"
import script from "./yincan.vue?vue&type=script&lang=js&"
export * from "./yincan.vue?vue&type=script&lang=js&"
import style0 from "./yincan.vue?vue&type=style&index=0&id=42a77c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a77c66",
  null
  
)

export default component.exports